/**
 * Copy de cara al cliente del catálogo, centralizado para permitir tests verbatim
 * (si alguien edita un texto, el test cae). Empieza con el buscador dentro de las
 * secciones de filtros (docs/specs/catalogo-filtros-buscador-opciones-plan.md).
 */
export const CATALOG_COPY = {
  filterSearch: {
    placeholder: 'Buscar...',
    /** Lleva el placeholder `{section}` (ver `withSection`), interpolado con `section.title`. */
    ariaLabel: 'Buscar dentro de {section}',
    /** Lleva el placeholder `{term}` (ver `withTerm`), interpolado con el término escrito. */
    noResults: 'No encontramos "{term}" en esta lista.',
  },
} as const;

/** Sustituye el placeholder `{section}` del aria-label del buscador por el título de la sección. */
export function withSection(ariaLabel: string, section: string): string {
  return ariaLabel.replace('{section}', section);
}

/** Sustituye el placeholder `{term}` del mensaje de sin-coincidencias por el término buscado. */
export function withTerm(noResults: string, term: string): string {
  return noResults.replace('{term}', term);
}
